import template from "./app.html";
import "./app-rtl.scss";

let appComponent = {
  template,
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component-rtl.js